var exports = {
  "l": "confirm__2SzKPs",
  "K": "copilotRun__sDIqDL",
};

module.exports = exports;
